export default {
      id: "settings-usage",
      viewBox: "0 0 266.4 266.4",
      url: __webpack_public_path__ + "img/icons.0fe16570.svg#settings-usage",
      toString: function () {
        return this.url;
      }
    }